<mat-slide-toggle
  color="accent"
  [checked]="checked"
  (click)="$event.stopPropagation()"
  [disableRipple]="true"
  (change)="onValueChange.emit($event)"
>
  <span style="font-size: 0.7em;font-weight: 500;color: var(--focus-text-color)">{{title}}</span>
</mat-slide-toggle>
